import { render } from "./SpinnerSmall.vue?vue&type=template&id=22d52871&scoped=true"
import script from "./SpinnerSmall.vue?vue&type=script&lang=js"
export * from "./SpinnerSmall.vue?vue&type=script&lang=js"

import "./SpinnerSmall.vue?vue&type=style&index=0&id=22d52871&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d52871"]])

export default __exports__